<template>
	<div class="audit-idcard-upload">
		<div class="audit-idcard-upload__title">
			<span class="audit-idcard-upload__required">*</span>上传身份证
		</div>
		<div class="audit-idcard-upload__body">
			<div class="audit-idcard-upload__side">
				<base-upload
					:value="frontList"
					:limit="1"
					:disabled="disabled"
					:repeat-upload="false"
					@input="(val) => handleSideChange('frontList', val)"
					@success="handleFrontSuccess"
				/>
				<div class="audit-idcard-upload__label">身份证 人像面</div>
			</div>
			<div class="audit-idcard-upload__side">
				<base-upload
					:value="backList"
					:limit="1"
					:disabled="disabled"
					:repeat-upload="false"
					@input="(val) => handleSideChange('backList', val)"
					@success="handleBackSuccess"
				/>
				<div class="audit-idcard-upload__label">身份证 国徽面</div>
			</div>
		</div>
	</div>
</template>

<script>
// 身份证正反面上传卡片（对应小程序 idCardPhoto 字段，fieldValue 为 [人像面, 国徽面]）
export default {
	name: 'AuditIdcardUpload',
	props: {
		value: {
			type: Array,
			default: () => [],
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data: () => ({
		frontList: [],
		backList: [],
	}),
	watch: {
		// 外部值（预填/回填）变化时同步到本地列表；与本地 url 一致的变化（本组件 sync 回传）忽略，避免清掉上传中的文件
		value: {
			immediate: true,
			handler(val) {
				const front = val && val[0] ? val[0] : ''
				const back = val && val[1] ? val[1] : ''
				const localFront = this.frontList.length ? this.frontList[0].url || '' : ''
				const localBack = this.backList.length ? this.backList[0].url || '' : ''
				if (front === localFront && back === localBack) return
				this.frontList = front ? [{ url: front }] : []
				this.backList = back ? [{ url: back }] : []
			},
		},
	},
	methods: {
		// 选择/删除文件时更新本地列表并同步（此时 url 可能尚未生成）
		handleSideChange(key, val) {
			this[key] = val
			this.sync()
		},
		handleFrontSuccess() {
			this.$toast('上传成功')
			this.sync()
		},
		handleBackSuccess() {
			this.$toast('上传成功')
			this.sync()
		},
		// 上传完成/删除后把最新 url 同步给父级
		sync() {
			const list = [
				this.frontList.length ? this.frontList[0].url || '' : '',
				this.backList.length ? this.backList[0].url || '' : '',
			]
			this.$emit('change', list)
		},
	},
}
</script>

<style lang="less" scoped>
.audit-idcard-upload {
	background-color: #fff;

	&__title {
		padding: 14px 16px;
		font-size: 15px;
		font-weight: 500;
		color: #1f2329;
		border-bottom: 1px solid #f5f6f7;
	}

	&__required {
		margin-right: 2px;
		color: #fa5151;
	}

	&__body {
		display: flex;
		justify-content: space-around;
		padding: 14px 16px;
	}

	&__side {
		text-align: center;
	}

	&__label {
		margin-top: 6px;
		font-size: 13px;
		color: #1f2329;
	}
}
</style>
